<template>
  <as-dialogo
    ref="dialogoTermos"
    title="Termos de Uso"
    scrollable
    max-width="800px"
    hideCloseButton
  >
    <v-container fluid class="pa-2">
      <p>
        A presente, integrante das Condições Gerais de Uso, tem por objeto
        descrever a política de proteção de dados do SITE.
      </p>
      <p>
        O naModa.com.vc encara seriamente a privacidade e a proteção dos dados
        disponibilizados pelos seus utilizadores e reconhece o valor da sua
        privacidade, pelo que tomamos as medidas necessárias para garantir a
        proteção dos seus dados pessoais em todos os momentos em que estiver a
        utilizar o SITE.
      </p>
      <p>
        Para uma total utilização do nosso site, são necessários alguns dados de
        informação pessoal.
      </p>

      <p>
        Os dados pessoais solicitados nos formulários do SITE (nome, telefone,
        endereço de correio eletrônico, etc.) servem para gestão, navegação e
        consulta do próprio site. O usuário reconhece e concorda expressamente
        que a base de dados poderá ser total ou parcialmente cedida ou
        transferida a terceiros, desde que respeitada finalidade única e
        exclusiva de dar continuidade à atividade prestada pelo naModa.com.vc se
        existir uma obrigatoriedade legal nesse sentido. Quando autorizado, o
        naModa.com.vc pode enviar informação relevante e específica para cada
        Utilizador, sobre produtos e serviços. Sempre que um Usuário decida que
        não pretende receber e-mail deverá mencionar tal fato ao naModa.com.vc,
        por meio dos canais de atendimento disponibilizados pelo SITE.
      </p>

      <p>
        A responsabilidade pela exatidão dos dados inseridos no SITE é exclusiva
        dos Usuários e/ou Anunciantes, por isso, caso sejam fornecidas
        informações falsas, o naModa.com.vc reserva-se ao direito de negar o
        acesso ao SITE.
      </p>

      <p>
        Os dados de caráter pessoal que forem disponibilizados pelos Usuários
        e/ou Anunciantes serão objeto de tratamento automatizado e incorporados
        aos arquivos automáticos do naModa.com.vc, sendo esta titular e
        responsável de seus próprios arquivos, os quais, conforme as normas
        legais vigentes encontram-se devidamente registrados.
      </p>

      <p>
        O naModa.com.vc garante a confidencialidade dos dados de caráter
        pessoal. Todavia, poderá revelar às autoridades públicas competentes os
        dados pessoais ou qualquer outra informação que estiver em seu poder, ou
        seja, acessível através de seus sistemas mediante solicitação que esteja
        em conformidade com as disposições legais e regulamentares aplicáveis ao
        caso.
      </p>

      <p>
        O Usuário aceita o uso de cookies e consente com o tratamento das
        informações que estão especificadas no presente documento. Os cookies
        poderão ser utilizados com a finalidade de facilitar ao máximo a
        navegação do Usuário pelo SITE, sem que tais Cookies proporcionem
        referências que permitam deduzir dados pessoais do Usuário nem dados do
        disco rígido de seu computador. Os cookies instalados se apagarão
        automaticamente uma vez finalizada sua navegação, exceto aqueles que,
        por motivos estritamente técnicos, devam ser mantidos instalados no
        computador dos Usuários. Não obstante, o Usuário pode configurar seu
        navegador para que notifique e cancele a instalação dos Cookies enviados
        pelo SITE, sem que tal cancelamento prejudique seu acesso aos conteúdos
        do mesmo. Seu endereço IP e outros dados oriundos da conexão com o seu
        computador são utilizados para personalizar o serviço e compreender como
        os Usuários se utilizam o SITE.
      </p>
    </v-container>

    <div slot="botoes_esquerda">
      <v-checkbox
        single-line
        hide-details
        class="my-auto ml-3"
        label="Li e Aceito"
        color="primary"
        v-model="aceito"
      ></v-checkbox>
    </div>
    <div slot="botoes" style="text-align: right">
      <v-btn depressed class="mx-4 my-2" @click="fechar">Cancelar</v-btn>
      <v-btn
        depressed
        color="primary"
        class="mx-4 my-2 ml-2"
        :disabled="!aceito"
        @click="aceitar"
        >Prosseguir</v-btn
      >
    </div>
  </as-dialogo>
</template>

<script>
import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  name: "TermosUso",
  data() {
    return {
      aceito: false,
    };
  },
  methods: {
    abrir() {
      this.aceito = false;
      this.$refs.dialogoTermos.abrir();
    },
    fechar() {
      this.$refs.dialogoTermos.fechar();
    },
    async aceitar() {
      this.$refs.dialogoTermos.fechar();
      this.$emit("success");
    },
  },
};
</script>

<style></style>
